<template>
  <div id="app">
    <app-navbar title='technorank' :class="{ 'vis-nav-custom': $route.path==='/Visualizations'}"></app-navbar>
    <router-view/>
  </div>
</template>

<script>
import Navbar from './components/navbar-1.vue'

export default {
  name: 'app',
  components: {
    'app-navbar': Navbar
  },
}
</script>

<style>
#app {
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #3c3950;
}
h2 {

  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  color: '#3c3950';
}
.navbar .navbar-nav {
  display: inline-block;
  float: none;
  vertical-align: top;

  font-family: 'Open Sans', sans-serif;
  color: '#3c3950';
}
.navbar .navbar-collapse {
  text-align: center;
}
ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.router-link-exact-active {
  background-color: #3dbdbe !important;
  color: #fff !important;
}

.router-link-exact-active:hover, .router-link-exact-active:focus, .router-link-exact-active:active {
  background-color: #3dbdbe !important;
  color: #fff !important;
}

.tag_custom {
  border: 2px solid #FFF !important;
  border-radius: 8px !important;
}
.lang_custom {
  border: 0px solid #FFF !important;
  border-radius: 8px !important;
}

.btn-group input[type="checkbox"] {
    display: none;
}

.btn-group input[type="checkbox"] + .btn-group > label span {
    width: 20px;
}

.btn-group input[type="checkbox"] + .btn-group > label span:first-child {
    display: none;
}
.btn-group input[type="checkbox"] + .btn-group > label span:last-child {
    display: inline-block;   
}

.btn-group input[type="checkbox"]:checked + .btn-group > label span:first-child {
    display: inline-block;
}
.btn-group input[type="checkbox"]:checked + .btn-group > label span:last-child {
    display: none;   
}
.btn-link {
  /*border-radius: 4px !important;*/
  color: #3c3950 !important;
}
.btn-link:hover, .btn-link:focus, .btn-link:active, .btn-link.active, .open > .dropdown-toggle.btn-link {
  color: #3dbdbe !important;
}
.btn-link:active, .btn-link.active {
  color: #3c3950 !important;
    box-shadow: none;
}
.btn-success {
  color: #fff !important;
  /*border-radius: 4px !important;*/
  background-color: #3dbdbe !important;
  /*border-color: #3dbdbe !important;*/
}
.btn-success:hover, .btn-success:focus, .btn-success:active, .btn-success.active, .open > .dropdown-toggle.btn-success {
  color: #fff !important;
    background: #3dbdbe !important;
}
.btn-success:active, .btn-success.active {
  color: #fff !important;
    background: #3dbdbe !important;
    box-shadow: none;
}

.btn-danger {
  color: #fff !important;
  /*border-radius: 4px !important;*/
  background-color: #c24a65 !important;
  /*border-color: #c24a65 !important;*/
}
.btn-danger:hover, .btn-danger:focus, .btn-danger:active, .btn-danger.active, .open > .dropdown-toggle.btn-danger {
  color: #fff !important;
    background: #c24a65 !important;
}
.btn-danger:active, .btn-danger.active {
  color: #fff !important;
    background: #c24a65 !important;
    box-shadow: none;
}

.btn-other {
  border: 2px solid #c24a65 !important;
}
.btn-other:hover, .btn-other:focus, .btn-other:active, .btn-other.active, .open > .dropdown-toggle.btn-other {
  border: 2px solid #c24a65 !important;
}
.btn-other:active, .btn-other.active {
  border: 2px solid #c24a65 !important;
}

.hashtags {
  text-align: left;
}

.infobox-not-sci {
  background-color: rgba(221,254,255,0.5) !important;
}

.infobox-sci {
  background-color: rgba(45,138,139,0.5) !important;
  /* color: #fff !important; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue